import { css } from "@mui/material";

export const menuSectionLabelNodeStyles = {
  sectionNodeLabelInnerDepth: css({
    lineHeight: "unset",
    paddingTop: 20,
    paddingBottom: 4,
    height: 48,
  }),
};
